<template>
  <div id="globalsearch" :class="[$root.deviceType]">
    <div class="searchBarContainer" v-if="!this.$root.isNutriverse">
      <input 
        class="searchField searchInput" 
        v-on:keyup.enter="search('enter')" 
        @input="search('wait')"
        v-model="searchTerm" 
        :placeholder="this.$root.language.wsm_Search"
        ref="searchInput"
      />
      <i v-if="!loading" class="fal fa-search"></i>
      <i v-if="loading" class="fas fa-spinner fa-pulse"></i>
    </div>
    <div v-show="searchTerm != '' && !loading && timer == null && show" @click="show = false" class="backdrop"></div>
    <transition name="fadeInUp" :duration="{ enter: 500, leave: 0 }">
      <result v-show="searchTerm != '' && !loading && timer == null && show" :loading="loading" :showLoader="showLoader"
        :result="searchResult" @scroll="handleResultScroll"></result>
    </transition>
  </div>
</template>

<script>
import result from "./components/result.vue";
export default {
  name: "globalSearch",
  components: {
    result,
  },
  data() {
    return {
      searchTerm: "",
      searchResult: {
        products: [],
        articles: [],
        videos: [],
      },
      localStorageData: {
        basedir: window.basedir,
        videos: {
          etag: "",
          data: {
            items: [],
          },
        },
        playlistItems: {
          etag: "",
          data: {
            items: [],
          },
        },
      },
      showLoader: false,
      timer: "",
      show: true,
      availableVideos: [],
      apiKey: "AIzaSyBdBmDYFLomPWxPsp0mYX_GAFqOn0oxlgo",
      changedApiKey: false,
      width: "",
      loading: false,
      articleSectionId:
        this.$root.articleSectionId != "" &&
          this.$root.articleSectionId != undefined
          ? this.$root.articleSectionId
          : 1004094,
      productsMatchSearch: [],
    };
  },
  created() {
    this.width = window.innerWidth;
    if (
      localStorage.getItem("pnyputube") != null &&
      JSON.parse(localStorage.getItem("pnyputube")).basedir == window.basedir
    ) {
      this.localStorageData = JSON.parse(localStorage.getItem("pnyputube"));
    }
  },
  watch: {
    searchTerm: function (oldVal, newVal) {
      if (newVal == "") {
        this.loading = false;
        this.showLoader = false;
        this.show = false;
      }
      this.searchResult = {
        products: [],
        articles: [],
        videos: [],
      };
    },
    deep: true,
  },
  methods: {
    searchBarExtend() {
      const searchBox = document.getElementById("searchBox");
      const searchIcon = document.getElementById("searchIcon");
      searchIcon.onclick = function () {
        searchBox.classList.toggle("searchBarActive");
      };
    },
    isJsonString(str) {
      try {
        JSON.parse(str.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
      } catch (e) {
        return false;
      }
      return true;
    },
    productIdExtactor(val) {
      return JSON.parse(
        val.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
      ).productId;
    },
    search(mode) {
      if (this.searchTerm.length >= 2) {
        if (
          this.searchResult.products.length > 0 ||
          this.searchResult.articles.length > 0
        ) {
          this.showLoader = true;
        }
        switch (mode) {
          case "wait":
            if (this.timer) {
              clearTimeout(this.timer);
              this.timer = null;
            }
            this.timer = setTimeout(() => {
              this.getSearchData();
              clearTimeout(this.timer);
              this.timer = null;
            }, 700);
            break;
          case "enter":
            if (this.timer) {
              clearTimeout(this.timer);
              this.timer = null;
              clearTimeout(this.timer);
              this.timer = null;
              if (document.activeElement === this.$refs.searchInput) {
                this.$refs.searchInput.blur();
              }
            }
            this.getSearchData();
            break;
        }
      }
    },
    getHeaders(key) {
      if (this.localStorageData[key].etag != "") {
        return {
          headers: {
            "Content-Type": "application/javascript",
            "cache-control": "max-age=86400",
            "If-None-Match": this.localStorageData[key].etag,
            "If-Match": this.localStorageData[key].etag,
          },
        };
      } else {
        return {};
      }
    },
    // Search through videos function
    pushVideos(items) {
      this.searchResult.videos = [];
      for (let vid in items) {
        let video = items[vid];
        let matchFound = false;
        // Add resourceId.videoId so it matches the same setup as the youTubeWidget. This might be a temporary fix bacause there is some inconsisty in how the videoData is recieved from the Ajaxcall
        this.$set(video.snippet, "resourceId", []);
        video.snippet.resourceId["videoId"] = video.id;
        // Checks if video has tags
        if (video.snippet.hasOwnProperty("tags")) {
          this.$set(video, "productIds", []);
          // Check if tags contains productId's from youtube and at the same time search for a match in tags
          video.snippet.tags.forEach((tag) => {
            // if its a product id
            if (this.isJsonString(tag)) {
              video["productIds"].push(this.productIdExtactor(tag));
            }
            // Search the tags for matching results
            if (
              tag.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0 &&
              !matchFound
            ) {
              matchFound = true;
              //console.log("%cmatch found in TAGS", "background:green")
            }
          });
        }
        // If match found, push the video to search result otherwise search the title and description for a match
        if (matchFound) {
          this.searchResult.videos.push(video);
        } else {
          if (
            video.snippet.title
              .toLowerCase()
              .indexOf(this.searchTerm.toLowerCase()) >= 0 ||
            video.snippet.description
              .toLowerCase()
              .indexOf(this.searchTerm.toLowerCase()) >= 0 ||
            video.snippet.title
              .toLowerCase()
              .indexOf(this.searchTerm.toLowerCase().replace(" ", "-")) >= 0
          ) {
            //console.log("%cMatch found in title or descreption", "background: green;")
            this.searchResult.videos.push(video);
          }
        }
      }
    },
    async getSearchData() {
      this.loading = true;
      if(statisticsAccepted()) {
        gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href.includes("?")
            ? window.location.href + "&q=" + this.searchTerm
            : window.location.href + "?q=" + this.searchTerm,
          page_path: window.location.pathname,
        });
        if(window.hasFbq) {
          fbq('track', 'Search', {
              search_string: this.searchTerm
          });
        }
      }
      var searchTerm = "";
      await axios
        .get(
          window.basedir +
          "/ajaxRequestServlet?mode=FreeSearch&isPointShop=" +
          false +
          "&isProductOverview=true",
          { params: { searchString: this.searchTerm } },
          {
            headers: {
              "Content-type": "application/json",
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
          }
        )
        .then((response) => {
          this.productsMatchSearch = [];        
          this.productsMatchSearch = response.data.productsByAttribute.flatMap(category => 
            category.globalProducts.flatMap(globalProduct => 
              globalProduct.products.map(product => ({
                ...product,
                globalProductName: globalProduct.name,
                globalProductDescription: globalProduct.description,
                globalProductImageUrl: globalProduct.imageUrl,
                globalProductPageLink: globalProduct.productPageLink,
                globalProductId: globalProduct.globalProductId,
                category: category.name
              }))
            )
          );
          //save the products separated into juridic attributes into one single array, to present them into the search result
        
          this.searchResult.products =
            response.data.productsByAttribute.length > 0
              ? this.productsMatchSearch
              : [];
          this.searchResult.articles = [];
          axios
            .post(
              basedir +
              "/ajaxRequestServlet?mode=ArticleSearch&searchString=" +
              this.searchTerm +
              "&searchAreas=longDescription&tagId=" +
              this.articleSectionId,
              {
                headers: {
                  "Content-type": "application/json",
                },
              }
            )
            .then((response) => {
              this.searchResult.articles = response.data.news.filter(
                (article) => article.publicationStatus == true
              );
              if (!this.changedApiKey) {
                if(statisticsAccepted()) {
                  gtag("event", "page_view", {
                    page_title: document.title,
                    page_location: window.location.href + "?q=" + this.searchTerm,
                    page_path: window.location.pathname,
                  });
                  gtag("event", "search", {
                    search_term: this.searchTerm,
                    result:
                      this.searchResult.articles.length > 0 ||
                        this.searchResult.products.length > 0
                        ? "products: " +
                        this.searchResult.products.length +
                        ", articles: " +
                        this.searchResult.articles.length
                        : "No result",
                  });
                }
              }
              // Get videos comes here
              this.getVideos();
            });
        });
    },
    getVideos() {
      this.loading = false;
      this.showLoader = false;
      this.show = true;
      if (this.localStorageData.videos.data.items.length > 0) {
        var videoIds = [];
        this.localStorageData.playlistItems.data.items.forEach((vid, index) => {
          videoIds.push(vid.contentDetails.videoId);
        });
        axios
          .get(
            window.basedir +
            "/ajaxRequestServlet?mode=VideoParser&endPoint=videos&part=snippet,contentDetails&id=" +
            videoIds +
            "&key=" +
            this.apiKey,
            this.getHeaders("videos")
          )
          .then((videos) => {
            var result = videos;
            //videos.
            this.localStorageData.videos.etag = videos.data.etag;
            this.localStorageData.videos.data = videos.data;
            this.pushVideos(videos.data.items);
          })
          .catch((error) => {
            if (error.response.status == 304) {
              this.pushVideos(this.localStorageData.videos.data.items);
            }
          });
      } else {
        axios
          .get(
            window.basedir +
            "/ajaxRequestServlet?mode=VideoParser&endPoint=channels&id=" +
            this.$root.channel +
            "&key=" +
            this.apiKey +
            "&part=contentDetails"
          )
          .then((channels) => {
            axios
              .get(
                window.basedir +
                "/ajaxRequestServlet?mode=VideoParser&endPoint=playlistItems&maxResults=99&key=" +
                this.apiKey +
                "&part=snippet,contentDetails&playlistId=" +
                channels.data.items[0].contentDetails.relatedPlaylists
                  .uploads,
                this.getHeaders("playlistItems")
              )
              .then((playlistItems) => {
                this.localStorageData.playlistItems.etag =
                  playlistItems.data.etag;
                this.localStorageData.playlistItems.data = playlistItems.data;
                var videoIds = [];
                playlistItems.data.items.forEach((vid, index) => {
                  videoIds.push(vid.contentDetails.videoId);
                });
                axios
                  .get(
                    window.basedir +
                    "/ajaxRequestServlet?mode=VideoParser&endPoint=videos&part=snippet,contentDetails&id=" +
                    videoIds +
                    "&key=" +
                    this.apiKey,
                    this.getHeaders("videos")
                  )
                  .then((videos) => {
                    this.localStorageData.videos.etag = videos.data.etag;
                    this.localStorageData.videos.data = videos.data;
                    this.availableVideos = videos.data.items;
                    this.pushVideos(this.localStorageData.videos.data.items);
                    localStorage.setItem(
                      "pnyputube",
                      JSON.stringify(this.localStorageData)
                    );
                  })
                  .catch((error) => {
                    if (error.response.status == 304) {
                      this.pushVideos(this.availableVideos);
                    }
                  });
              })
              .catch((error) => {
                var videoIds = [];
                if (error.response.status == 304) {
                  this.localStorageData.playlistItems.data.items.forEach(
                    (vid, index) => {
                      videoIds.push(vid.contentDetails.videoId);
                    }
                  );
                  this.pushVideos(
                    this.localStorageData.playlistItems.data.items
                  );
                }
              });
          });
      }
    },
    handleResultScroll() {
      if (document.activeElement === this.$refs.searchInput) {
        this.$refs.searchInput.blur();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.searchBarContainer {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  -webkit-box-sizing: border-box !important;
  margin: 0 auto;
  .fa-search, .fa-pulse {
    font-family: "Font Awesome 5 Pro";
    position: absolute;
    right: 15px;
    font-size: 1.2em;
    font-weight: 400;
    color: #0000007a;
  }
}
.searchField {
  box-sizing: border-box;
  margin-bottom: 0;
  padding: 0;
  height: 40px;
  padding-left: 15px;
  width: 100%;
  border-radius: 6px;
  outline: none;
  border: 1px solid #cbcbcb;
  background: #f1f1f1;
  font-size: 1.2rem;
}
.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.backdrop {
  height: 100vh;
  position: fixed;
  width: 100vw;
  right: 0;
  top: 59%;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.3s ease-out;
}

.fadeInUp-leave-active {
  animation: fadeInUp 0.3s reverse;
}


@media only screen and (max-width: 900px) {

}
@media only screen and (min-width: 764px) {
  .mobile {
    display: none;
  }
}
@media only screen and (max-width: 764px) {
  .desktop {
    display: none !important;
  }
  .searchField {
    width: 100%;
  }
  .result {
    width: calc(100% - 30px);
    margin: 0 auto;
  }
  .mobile {
    display: block;
  }
  .mobile {
    padding: 0;
    width:100%;
    margin: 0 auto;
    .searchBarContainer {
      margin:0;
      width:100%;
      .searchField {
        border: none;
        // padding-left: 15px;
        border-bottom:2px solid #2e4145;
        height:50px;
        border-radius: 0;
        width: 100%;
        // width: calc(100% - 15px);
        margin: 0;
      }
    }

  }
  .searchBarContainer {
    max-width: unset;
    width: calc(92% - 19px);
    margin: 19px;
    input {
      border-radius: 13px;
      border: 1px solid #2e4145;
    }
  }
}
</style>


